module.exports = __webpack_public_path__ + "static/img/6-2-2.723b5f2a.jpg";